function InstagramLink(data){
	var self = this;
	self.type = "InstagramLink"

    self.rootvm = data.rootvm;

    self.link_uuid = ko.observable(data.link_uuid);
    self.link_url= ko.observable(data.link_url);
    self.link_text = ko.observable(data.link_text);


    self.save_edits = function(){

        console.log('saving edits');
        return $.ajax({
            url: self.rootvm.web_host + '/api/admin/ig-link',
            type: 'POST',
            data:ko.toJSON({
                link_uuid: self.link_uuid(),
                link_url: self.link_url(),
                link_text : self.link_text(),
            }),
            processData: false,

            contentType: "application/json; charset=utf-8",

            success: function (data) {
               if (data.success){

                   // set new type
                   notyf.success("saved!")
               }
               else{
                   notyf.error(data.message);
               }

            },
            error: function (jqXHR, errorStatus, thrownError) {
                var response = jQuery.parseJSON(jqXHR.responseText);
                notyf.error(response.message);
            }
        });
    }

};


export function InstagramViewModel(data) {

    var self = this;
    self.type = "InstagramViewModel";

    self.rootvm = data.rootvm;

    self.ig_links= ko.observableArray([]);

    self.initialized = ko.observable(false);
    self.initialize = function(){

        if (!self.initialized()){
          self.lookup_ig_links().then(function(){
                console.log('done looking up ig_links ');
                self.initialized(true);
          })};
    }


    self.lookup_ig_links = function(){
        self.rootvm.is_busy(true);

        // we need to add in a filter as well..
        return $.ajax({

            url: self.rootvm.web_host + '/api/ig-links',
            type: 'GET',
            data:{
            },

            contentType: "application/json; charset=utf-8",
            success: function (data) {

                self.ig_links(ko.utils.arrayMap( data.ig_links || [],
                    function(x){
                        x.rootvm = self.rootvm
                        return new InstagramLink(x);
                    }));

            },
            error: function (data) {
                self.error(data.statusText);
            },
            complete: function(){
                self.rootvm.is_busy(false);
            }
        });
    };
};
